import { useCallback } from 'react';

import type { TrackingEventType } from 'src/components/app/types';
import { useEmitTrackingEventCallback } from 'src/hooks/hooks';

const useAIStudioTracking = () => {
  const emitTrackingEvent = useEmitTrackingEventCallback();

  return useCallback(
    (
      eventType: Extract<
        TrackingEventType,
        | 'studio_display_mode_changed'
        | 'studio_session_started'
        | 'conversation_started'
        | 'message_sent'
        | 'flashback_saved'
        | 'flashback_deleted'
        | 'copy_text_error'
        | 'export_to_pdf_error'
      >,
      params?: Record<string, unknown>,
    ) => {
      emitTrackingEvent(eventType, {
        ...params,
        feature: 'ai_studio',
      });
    },
    [emitTrackingEvent],
  );
};

export default useAIStudioTracking;
